import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { LANGUAGE } from '@/domains/CommonDomain'
import { isDevelopmentMode } from '@/utils/environmentUtils'

async function loadLocaleMessages(currentLanguage: string) {
  const data = await import(
    /* webpackChunkName: "locale-chunk" */ `../../locales/${currentLanguage}.json`
  )
  const locales = data.default

  return { [currentLanguage]: locales }
}

export let $: any = () => {}

export async function init(currentLanguage: string) {
  return i18n
    .use(initReactI18next)
    .init({
      debug: isDevelopmentMode,
      load: 'currentOnly',
      interpolation: {
        escapeValue: true,
        prefix: '{',
        suffix: '}',
      },
      lng: currentLanguage,
      fallbackLng: LANGUAGE.EN,
      resources: await loadLocaleMessages(currentLanguage),
    })
    .then(t => {
      $ = t
    })
}
